import { Component, Event, EventEmitter, h, Host, Listen } from '@stencil/core';

@Component({
  tag: 'sofistik-language-toggle',
  styleUrl: './language-toggle.scss',
})
export class LanguageToggle {
  @Event() toggleLangNav: EventEmitter<void>;

  @Listen('click')
  toggleLanguageMenu() {
    this.toggleLangNav.emit();
  }

  render() {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
